import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import { TableContext } from './tableContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TableBody(_ref) {
  var rows = _ref.rows,
      _ref$noResultsPlaceho = _ref.noResultsPlaceholder,
      noResultsPlaceholder = _ref$noResultsPlaceho === void 0 ? 'No data' : _ref$noResultsPlaceho,
      _ref$isPlaceholderAct = _ref.isPlaceholderActive,
      isPlaceholderActive = _ref$isPlaceholderAct === void 0 ? false : _ref$isPlaceholderAct,
      props = _objectWithoutProperties(_ref, ["rows", "noResultsPlaceholder", "isPlaceholderActive"]);

  var _useContext = useContext(TableContext),
      refs = _useContext.refs,
      decoratedColumns = _useContext.decoratedColumns,
      renderers = _useContext.decoratedRenderers,
      composedRows = _useContext.composedRows,
      getBodyProps = _useContext.getBodyProps,
      rowRenderer = _useContext.bodyRowRenderer,
      _useContext$props = _useContext.props,
      rowKey = _useContext$props.rowKey,
      numRowsVisible = _useContext$props.numRowsVisible,
      groupedRows = _useContext$props.groupedRows;

  var BodyWrapperComponent = renderers.body.wrapper;
  return /*#__PURE__*/React.createElement(BodyWrapperComponent, _extends({
    classProps: {
      grouped: groupedRows
    }
  }, getBodyProps(_objectSpread(_objectSpread({}, props), {}, {
    innerRef: refs.body,
    innerBodyRef: refs.innerBody,
    rows: rows || composedRows.rows || composedRows,
    noResultsPlaceholder: noResultsPlaceholder,
    rowRenderer: rowRenderer,
    columns: decoratedColumns,
    rowKey: rowKey,
    numRowsVisible: numRowsVisible,
    isPlaceholderActive: isPlaceholderActive
  }))), "kajsd;klfajsd;fj");
}

var TableBody$1 = /*#__PURE__*/React.memo(TableBody);

export default TableBody$1;
//# sourceMappingURL=TableBody.js.map
